import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {ImportExportComponent} from '@app/_components/_helpers/import-export/import-export.component';
import {User} from '@app/_models';
import {LazyLoadEvent, MessageService} from 'primeng/api';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {AlertService, AuthenticationService, ConstantService} from '@app/_services';
import {ReservationService} from '@app/_components/reservation';
import {ActivatedRoute, Router} from '@angular/router';
import {PropertyService} from '@app/_components/property';
import {Location} from '@angular/common';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig} from '@angular/material/dialog';
import * as moment from 'moment';
import {first} from 'rxjs/operators';
import {Table} from 'primeng/table';
import {ReservationContainerComponent} from '@app/_components/reservation/components/reservation/reservation-container/reservation-container.component';
import {OrderComponent} from '@app/_components/order/order/order.component';
import {ReservationAdvanceSearchComponent} from '@app/_components/reservation/components/reservation-advance-search/reservation-advance-search.component';
import {ReservationCreateComponent} from '@app/_components/reservation/components/reservation-create/reservation-create.component';
import {WelcomeCardDialogComponent} from '@app/_components/reservation/components/welcome-card-dialog/welcome-card-dialog.component';

/* Date: 21-02-2025 Author: Dhruvit Patil
 * API to fetch the Reservation In-out report based on report format
 * https://docs.google.com/spreadsheets/d/1HzomeYKR5aK0Pe-szn1fVN3xV-vcwG6I74WOtXhsjmM/edit?gid=0#gid=0
 */
@Component({
    selector: 'app-reservation-in-out-list',
    templateUrl: './reservation-in-out-list.component.html',
    styleUrls: ['./reservation-in-out-list.component.css'],
    standalone: false
})
export class ReservationInOutListComponent implements OnInit {

  @ViewChild(ImportExportComponent) importExportComponent: ImportExportComponent;

  datasource: any[];
  reservation: User;
  reservations: any[] = [];
  recordTotal: number;
  lazyLoadEvent: LazyLoadEvent;
  loading = true;
  multiSortMeta = [];
  advanceSearchData: any = [];
  advanceSearchDataFilter: LazyLoadEvent = {};
  eventFilter: LazyLoadEvent = {};

  //For reservation list to be shown on dialog
  formTitle: String;
  reservationForPredicate: any;
  showCreateReservationPopUp = false;

  // forms
  form1: UntypedFormGroup;
  formLoading = false;
  formAlert: String;

  statuses: any;

  validationMessages = {
    shortTermRentalId: [{type: 'required', message: 'Required'}],
    emailAddress: [{type: 'required', message: 'Required'},
      {type: 'email', message: 'Not a valid Email'}],
    referralSourceId: [{type: 'required', message: 'Required'}],
    numAdults: [{type: 'required', message: 'Required'}],
    numChildren: [{type: 'required', message: 'Required'}],
    checkOutDate: [{type: 'required', message: 'Required'}],
    checkInDate: [{type: 'required', message: 'Required'}],
    firstName: [{type: 'required', message: 'Required'}],
    lastName: [{type: 'required', message: 'Required'}],
  };
  referralSources: any[];
  properties: any[] = [];
  numAdults: any[];
  searchName: any;
  searchData: { [k: string]: any; };
  activatedRoutePropertyCode: any;
  locations: any;

  reservationStatuses: any[] = [
    {label: 'Reserved', value: 'OP', color: 'lightgrey'},
    {label: 'Owner Occ', value: 'OO', color: 'hotpink'},
    {label: 'Owner Guest', value: 'OG', color: 'lightpink'}
  ];

  generatingWelcomeCard = false;
  
  // Track expanded state for opsNotes
  expandedOpsNotes: { [key: string]: boolean } = {};

  // Default value for HTML date inputs (yyyy-MM-dd)
  todayDateInput: string;
  // Ensure default date filter is applied only once on initial load
  isDefaultDateApplied: boolean = false;
  // Track whether any advanced search filters are active
  isAdvanceFilterActive: boolean = false;

  generateWelcomeCardFromList() {
    if (!this.reservations || this.reservations.length === 0) {
      this.alertService.error('No reservations found in the current search result.');
      return;
    }

    // Get reservation IDs from current list
    const reservationIds = this.reservations.map(reservation => reservation.reservationId);

    // Show info message about pop-up blocking
    this.alertService.warn('If the download doesn\'t start automatically, please check your browser\'s pop-up blocker settings and allow pop-ups for this site.');

    this.generatingWelcomeCard = true;
    this.formLoading = true;
    this.reservationService.generateWelcomeCard(reservationIds).subscribe({
      next: (blob: Blob) => {
        this.generatingWelcomeCard = false;
        this.formLoading = false;

                 if (blob && blob.size > 0) {
           // Create blob URL and download PDF
           const blobUrl = window.URL.createObjectURL(blob);
           
           // Generate filename with timestamp
           const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
           const fileName = `welcome-card-reservations-${timestamp}.pdf`;
           
           // Try multiple download approaches to handle pop-up blockers
           try {
             // Method 1: Direct download using anchor element
             const link = document.createElement('a');
             link.href = blobUrl;
             link.download = fileName;
             link.style.display = 'none';
             
             // Append to body, click, and remove
             document.body.appendChild(link);
             link.click();
             document.body.removeChild(link);
             
             // Method 2: If Method 1 fails, try opening in new window
             setTimeout(() => {
               try {
                 const newWindow = window.open(blobUrl, '_blank');
                 if (!newWindow) {
                   // Pop-up was blocked, show manual download instructions
                   this.alertService.warn('Pop-up blocked. Please right-click the link below and select "Save link as..." to download the PDF.');
                   const manualLink = document.createElement('a');
                   manualLink.href = blobUrl;
                   manualLink.download = fileName;
                   manualLink.textContent = 'Download Welcome Card PDF';
                   manualLink.style.display = 'block';
                   manualLink.style.padding = '10px';
                   manualLink.style.backgroundColor = '#007bff';
                   manualLink.style.color = 'white';
                   manualLink.style.textDecoration = 'none';
                   manualLink.style.borderRadius = '5px';
                   manualLink.style.margin = '10px 0';
                   document.body.appendChild(manualLink);
                 }
               } catch (e) {
                 console.error('Failed to open PDF in new window:', e);
               }
             }, 1000);

           } catch (e) {
             console.error('Download failed:', e);
             this.alertService.error('Download failed. Please try again or contact support.');
           }

           // Clean up the blob URL
           setTimeout(() => {
             window.URL.revokeObjectURL(blobUrl);
           }, 5000);

          // Show success message
          let successMessage = 'Welcome Card PDF downloaded successfully.';
          successMessage += ` File: ${fileName}`;

          this.alertService.success(successMessage);
        } else {
          this.alertService.error('No PDF data received from server.');
        }
      },
      error: (err) => {
        this.generatingWelcomeCard = false;
        this.formLoading = false;
        this.alertService.error('Failed to generate Welcome Card PDF.');
        console.error('PDF generation error:', err);
      }
    });
  }

  generateWelcomeCardFromListWithFilter() {
    // Prepare current filters for the dialog
    let event = this.lazyLoadEvent;
    let currentFilters = {};

    if (event.filters && Object.keys(event.filters).length > 0) {
      this.eventFilter = event.filters;
      currentFilters = {...event.filters};
    }
    if (this.advanceSearchDataFilter.filters && Object.keys(this.advanceSearchDataFilter.filters).length > 0) {
      currentFilters = {...this.advanceSearchDataFilter.filters, ...currentFilters};
    }

    // Open the welcome card dialog
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '500px';
    dialogConfig.data = {
      currentFilters: currentFilters
    };

    const dialogRef = this.dialog.open(WelcomeCardDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.generateWelcomeCardWithFilters(result.filters, result.locationName);
      }
    });
  }

  generateWelcomeCardWithFilters(filters: any, locationName?: string) {
    let newWindow: Window | null = null;

    try {
      let event = this.lazyLoadEvent;

      // Use the filters from the dialog
      event.filters = filters;

      // Open new tab with loading page
      const loadingHtml = `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Generating Welcome Card...</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100vh;
              margin: 0;
              background-color: #f5f5f5;
            }
            .loading-container {
              text-align: center;
              padding: 40px;
              background: white;
              border-radius: 8px;
              box-shadow: 0 2px 10px rgba(0,0,0,0.1);
            }
            .spinner {
              border: 4px solid #f3f3f3;
              border-top: 4px solid #3498db;
              border-radius: 50%;
              width: 50px;
              height: 50px;
              animation: spin 1s linear infinite;
              margin: 0 auto 20px;
            }
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
            h2 {
              color: #333;
              margin-bottom: 10px;
            }
            p {
              color: #666;
              margin: 0;
            }
          </style>
        </head>
        <body>
          <div class="loading-container">
            <div class="spinner"></div>
            <h2>Generating Welcome Card</h2>
            <p>Please wait while we generate your welcome card${locationName ? ` for ${locationName}` : ''}...</p>
          </div>
        </body>
        </html>
      `;
      const blob = new Blob([loadingHtml], {type: 'text/html'});
      const loadingUrl = URL.createObjectURL(blob);
      newWindow = window.open(loadingUrl, '_blank');

      // Clean up the loading URL after a delay
      setTimeout(() => {
        URL.revokeObjectURL(loadingUrl);
      }, 1000);

             this.generatingWelcomeCard = true;

       // Show info message about pop-up blocking
       this.alertService.warn('If the download doesn\'t start automatically, please check your browser\'s pop-up blocker settings and allow pop-ups for this site.');

       console.log('EVENT ' + JSON.stringify(event));
      console.log(
        ' event.first:' + event.first
        + '  |  event.rows:' + event.rows
        + '  |  event.sortField:' + event.sortField
        + '  |  event.sortOrder:' + event.sortOrder
        + '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
        + '  |  event.globalFilter:' + event.globalFilter
        + '  |  event.filters:' + JSON.stringify(event.filters)
      );
      // https://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object
      // if we are filtering by some field (ie property) (event.filters are not empty {})
      if (Object.keys(event.filters).length > 0) {
        console.log('FILTERS!');
        // if there are no other sorts, initialize the event.multiSortMeta
        if (!event.multiSortMeta) {
          event.multiSortMeta = [];
        }
        // sort by checkInDateTime
        event.multiSortMeta.push({field: 'checkInDateTime', order: -1});
      } else {
        // sort by createDate
        console.log('NO MULTI!');
        if (!event.multiSortMeta) {
          event.multiSortMeta = [];
        }
        event.multiSortMeta.push({field: 'createDate', order: -1});
      }

      //Show only predicate reservation list if it's not null. Used for future occupancy
      if (this.reservationForPredicate != null && this.reservationForPredicate.shortTermRentalId != null) {
        let reservationFilter = {'shortTermRentalVO.shortTermRentalId': {'value': this.reservationForPredicate.shortTermRentalId, 'matchMode': 'in'}};
        Object.assign(event.filters, reservationFilter);
        event.multiSortMeta = [];
        event.multiSortMeta.push({field: 'checkInDateTime', order: -1});
      }

      if (event.filters?.checkInDateTime) {
        event.filters.checkInDateTime.value = moment(event.filters.checkInDateTime.value).format('MM/DD/YYYY');
      }

      if (event.filters?.checkOutDateTime) {
        event.filters.checkOutDateTime.value = moment(event.filters.checkOutDateTime.value).format('MM/DD/YYYY');
      }

      if (this.activatedRoutePropertyCode) {
        // show only activities that are assigned to this activityFeeId
        let rateBucketIdFilter = {'shortTermRentalVO.propertyCode': {'value': this.activatedRoutePropertyCode, 'matchMode': 'in'}};
        Object.assign(event.filters, rateBucketIdFilter);
      }
      if (event.filters?.global) {
        event.filters.global.value = event.filters.global.value.trim();
        this.searchName = event.filters.global.value.trim();
      }
      if (event.globalFilter == null && this.searchName != null && this.searchName != '') {
        event.filters.global = {
          matchMode: 'contains',
          value: this.searchName
        };
        event.globalFilter = this.searchName;
      }
      const pageNumber = Math.round(event.first / event.rows);

      this.reservationService.generateWelcomeCardWithFilter(pageNumber, event.rows,
        event.sortField,
        event.sortOrder,
        event.multiSortMeta,
        event.globalFilter,
        event.filters).pipe(first()).subscribe({
        next: (blob: Blob) => {
          this.generatingWelcomeCard = false;

          // Close the loading window if it exists
          if (newWindow && !newWindow.closed) {
            newWindow.close();
          }

                     if (blob && blob.size > 0) {
             // Create blob URL and download PDF
             const blobUrl = window.URL.createObjectURL(blob);
             
             // Generate filename with timestamp
             const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
             const fileName = `welcome-card-${locationName ? locationName.replace(/\s+/g, '-').toLowerCase() : 'filtered'}-${timestamp}.pdf`;
             
             // Try multiple download approaches to handle pop-up blockers
             try {
               // Method 1: Direct download using anchor element
               const link = document.createElement('a');
               link.href = blobUrl;
               link.download = fileName;
               link.style.display = 'none';
               
               // Append to body, click, and remove
               document.body.appendChild(link);
               link.click();
               document.body.removeChild(link);
               
               // Method 2: If Method 1 fails, try opening in new window
               setTimeout(() => {
                 try {
                   const newWindow = window.open(blobUrl, '_blank');
                   if (!newWindow) {
                     // Pop-up was blocked, show manual download instructions
                     this.alertService.warn('Pop-up blocked. Please right-click the link below and select "Save link as..." to download the PDF.');
                     const manualLink = document.createElement('a');
                     manualLink.href = blobUrl;
                     manualLink.download = fileName;
                     manualLink.textContent = 'Download Welcome Card PDF';
                     manualLink.style.display = 'block';
                     manualLink.style.padding = '10px';
                     manualLink.style.backgroundColor = '#007bff';
                     manualLink.style.color = 'white';
                     manualLink.style.textDecoration = 'none';
                     manualLink.style.borderRadius = '5px';
                     manualLink.style.margin = '10px 0';
                     document.body.appendChild(manualLink);
                   }
                 } catch (e) {
                   console.error('Failed to open PDF in new window:', e);
                 }
               }, 1000);

             } catch (e) {
               console.error('Download failed:', e);
               this.alertService.error('Download failed. Please try again or contact support.');
             }

             // Clean up the blob URL
             setTimeout(() => {
               window.URL.revokeObjectURL(blobUrl);
             }, 5000);

            // Show success message
            let successMessage = 'Welcome Card PDF downloaded successfully.';
            if (locationName) {
              successMessage += ` for ${locationName}`;
            }
            successMessage += ` File: ${fileName}`;

            this.alertService.success(successMessage);
          } else {
            this.alertService.error('No PDF data received from server.');
          }
        },
        error: (err) => {
          this.generatingWelcomeCard = false;

          // Close the loading window if it exists
          if (newWindow && !newWindow.closed) {
            newWindow.close();
          }

          this.alertService.error('Failed to generate Welcome Card PDF.');
          console.error('PDF generation error:', err);
        }
      });
    } catch (error) {
      this.generatingWelcomeCard = false;

      // Close the loading window if it exists
      if (newWindow && !newWindow.closed) {
        newWindow.close();
      }

      console.log('generateWelcomeCardWithFilters error: ' + error);
    }
  }
  reservationInOutTypes: any[] = [
    { label: 'In', value: 'IN' },
    { label: 'Out', value: 'OUT' },
  ];
  constructor(
    public authenticationService: AuthenticationService,
    public reservationService: ReservationService,
    public alertService: AlertService,
    public constantService: ConstantService,
    private messageService: MessageService,
    private formBuilder: UntypedFormBuilder,
    public router: Router,
    private _activatedRoute: ActivatedRoute,
    private propertyService: PropertyService,
    private location1: Location,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.formTitle = data.title,
      this.reservationForPredicate = data.reservation;
    this.referralSources = this.reservationService.referralSources;
    this.numAdults = this.reservationService.numAdults;
    if (this._activatedRoute.snapshot.paramMap.get('propertyCode')) {
      this.activatedRoutePropertyCode = this._activatedRoute.snapshot.paramMap.get('propertyCode');
      }
    this.locations = this.constantService.locations;
  }


  ngOnInit() {
    this._activatedRoute.queryParams.subscribe(params => {
      this.searchData = params['searchName'];
    });
    if (this.searchData != null && this.searchData != undefined) {
      this.searchName = this.searchData;
    }
    this.todayDateInput = this.getTodayDateInputValue();
    this.formBuild();
    this.fetchProperties();
  }

  fetchProperties() {
    try {
      this.propertyService.findAllSummaryWithStatusActiveAndSuspended()
        .subscribe(
          res => {
            // console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
            this.properties = res.data.properties;
          },
          err => {
            console.log('Feature-Update FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => {
          });
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  private getTodayDateInputValue(): string {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  formBuild() {
    this.form1 = this.formBuilder.group({
      shortTermRentalId: ['', Validators.required],
      referralSourceId: ['', Validators.required],
      numAdults: ['', Validators.required],
      numChildren: ['', Validators.required],
      checkOutDate: ['', Validators.required],
      checkInDate: ['', Validators.required],
      guestProfile: this.formBuilder.group({
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        emailAddress: ['', Validators.compose([Validators.required, Validators.email])],
        guestCompanions: new UntypedFormArray([]),
      }),
    });
  }


  loadLazy(event: LazyLoadEvent) {
    try {
      // Ensure filters object exists to avoid undefined access
      event.filters = event.filters || {};
      console.log(this.advanceSearchDataFilter);
      if (event.filters && Object.keys(event.filters).length > 0) {
        this.eventFilter = event.filters;
      }
      if (this.advanceSearchDataFilter.filters && Object.keys(this.advanceSearchDataFilter.filters).length > 0) {
        //combine objects
        event.filters = {...this.advanceSearchDataFilter.filters, ...event.filters};
      }
      // Determine if advanced filters are active
      this.isAdvanceFilterActive = !!(this.advanceSearchDataFilter.filters && Object.keys(this.advanceSearchDataFilter.filters).length > 0);
      // Apply today's date as default filter for checkIn only if no advanced filters are active
      if (!this.isAdvanceFilterActive) {
        if (!this.isDefaultDateApplied) {
          const todayVal = this.todayDateInput || this.getTodayDateInputValue();
          if (!event.filters['checkInDateTime']) {
            event.filters['checkInDateTime'] = { value: todayVal, matchMode: 'in' };
          }
          this.isDefaultDateApplied = true;
        }
      } else {
        // If advanced filters are active and default check-in was previously applied, remove it
        const todayVal = this.todayDateInput || this.getTodayDateInputValue();
        if (event.filters && event.filters['checkInDateTime']
          && event.filters['checkInDateTime'].matchMode === 'in'
          && event.filters['checkInDateTime'].value === todayVal) {
          delete event.filters['checkInDateTime'];
        }
      }
      this.loading = true;
      this.lazyLoadEvent = event;
      console.log('EVENT ' + JSON.stringify(event));
      console.log(
        ' event.first:' + event.first
        + '  |  event.rows:' + event.rows
        + '  |  event.sortField:' + event.sortField
        + '  |  event.sortOrder:' + event.sortOrder
        + '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
        + '  |  event.globalFilter:' + event.globalFilter
        + '  |  event.filters:' + JSON.stringify(event.filters)
      );

      // Sorting logic
      if (Object.keys(event.filters).length > 0) {
        if (!event.multiSortMeta) {
          event.multiSortMeta = [];
        }
        event.multiSortMeta.push({field: 'checkInDateTime', order: -1});
      } else {
        if (!event.multiSortMeta) {
          event.multiSortMeta = [];
        }
        event.multiSortMeta.push({field: 'createDate', order: -1});
      }

      // Predicate reservation filter
      if (this.reservationForPredicate != null && this.reservationForPredicate.shortTermRentalId != null) {
        let reservationFilter = {'shortTermRentalVO.shortTermRentalId': {'value': this.reservationForPredicate.shortTermRentalId, 'matchMode': 'in'}};
        Object.assign(event.filters, reservationFilter);
        event.multiSortMeta = [];
        event.multiSortMeta.push({field: 'checkInDateTime', order: -1});
      }

      // Date formatting
      if (event.filters?.checkInDateTime) {
        event.filters.checkInDateTime.value = moment(event.filters.checkInDateTime.value).format('MM/DD/YYYY');
      }
      if (event.filters?.checkOutDateTime) {
        event.filters.checkOutDateTime.value = moment(event.filters.checkOutDateTime.value).format('MM/DD/YYYY');
      }

      // Property code filter
      if (this.activatedRoutePropertyCode) {
        let rateBucketIdFilter = {'shortTermRentalVO.propertyCode': {'value': this.activatedRoutePropertyCode, 'matchMode': 'in'}};
        Object.assign(event.filters, rateBucketIdFilter);
      }

      // Global filter
      if (event.filters?.global) {
        event.filters.global.value = event.filters.global.value.trim();
        this.searchName = event.filters.global.value.trim();
      }
      if (event.globalFilter == null && this.searchName != null && this.searchName != '') {
        event.filters.global = {
          matchMode: 'contains',
          value: this.searchName
        };
        event.globalFilter = this.searchName;
      }

      const pageNumber = Math.round(event.first / event.rows);

      this.reservationService.findByAgentListFilterInOutReport(
        pageNumber, event.rows,
        event.sortField,
        event.sortOrder,
        event.multiSortMeta,
        event.globalFilter,
        event.filters).pipe(first()).subscribe(
        res => {
          // console.log('reservations are: ' + JSON.stringify(apiResponse));
          this.datasource = res.data.reservations;
          this.recordTotal = res.page.recordTotal;
          this.reservations = res.data.reservations;
          this.location1.go('/reservation-in-out-list');
        },
        error => {
          console.log('USER LIST!: ' + JSON.stringify(error));
          this.alertService.error(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );

      // No need to slice, as we now use the full decorated array for the page
    } catch (error) {
      console.log('loadLazy(' + event + ')' + error);
      this.loading = false;
    }
  }

  onRowSelect(event) {
    try {
      // use this for adding query params
      // this.router.navigate(['reservation-edit'], { queryParams: { reservationId: event.data.reservationId } });
      // this.router.navigate(['reservations', event.data.reservationId]);
      this.onOpenFormEdit(event.data);
    } catch (error) {
      console.log('onRowSelect(' + event + ')' + error);
    }
  }

  getLocationName(locationId: any) {
    if (locationId != null) {
      const status = this.locations.find((e: any) => e.locationId == locationId);
      return status.name;
    } else {
      return '';
    }
  }

  getTagNameFromTagList(tagList: any) {
    let tagName = '';
    if (tagList) {
      let combineTagName = '';
      for (let i = 0; i < tagList.length; i++) {
        combineTagName = combineTagName + tagList[i].name + ', ';
      }
      if (combineTagName.length > 0) {
        tagName = combineTagName.substring(0, combineTagName.length - 2);
      }
    }
    return tagName;
  }

  getResStatusName(resStatus) {
    if (resStatus != null && resStatus != undefined && resStatus != '') {
      return this.constantService.reservationStatuses.find(function (item) {
        return item.value === resStatus;
      }).label;
    } else {
      return '';
    }
  }

  getResStatusColor(resStatus) {
    if (resStatus != null && resStatus != undefined && resStatus != '') {
      return this.constantService.reservationStatuses.find(function (item) {
        return item.value === resStatus;
      }).color;
    } else {
      return '';
    }

  }

  clear(table: Table) {
    table.clear();
  }

  reloadPage() {
    window.location.reload();
  }

  /*********
   * Add New Button
   *
   */
  onOpenFormAdd() {

    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    dialogConfig.maxWidth = '100vw';
    dialogConfig.width = '95vw';
    dialogConfig.maxHeight = '50vw';
    dialogConfig.height = '95vh';

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: 'Add Reservation'
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(ReservationContainerComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    // dialogRef.componentInstance.doAdd.subscribe(
    // 	data => {
    // 		console.log('Dialog output:', data);

    // 		// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
    // 		this.addReservationCB(data);

    // 		// close the dialogBox
    // 		dialogRef.close();
    // 	});
  }


  /*********
   * Edit Button
   *
   */
  // onOpenFormEdit(reservation: any) {

  // 	const dialogConfig = new MatDialogConfig();

  // 	// settings
  // 	dialogConfig.disableClose = false;
  // 	dialogConfig.autoFocus = true;
  // 	dialogConfig.hasBackdrop = true;
  //   dialogConfig.maxWidth = "100vw";
  // 		dialogConfig.width = "95vw";
  //     dialogConfig.maxHeight = "50vw";
  // 		dialogConfig.height = "95vh";

  // 	// pass data, ie rateBuicket: this.shortTermRentalId,
  // 	dialogConfig.data = {
  // 		reservationId: reservation.reservationId,
  //     reservation: reservation,
  //     showCloseButton: true,
  // 		title: 'Edit Order'
  // 	};

  // 	// open the popup and get a reference to it called dialogRef
  // 	const dialogRef = this.dialog.open(ReservationContainerComponent, dialogConfig);
  //   this.location1.go('/reservations-edit/' + reservation.reservationId);

  // 	// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
  // 	// dialogRef.componentInstance.doUpdate.subscribe(
  // 	// 	data => {
  // 	// 		console.log('Dialog output:', data);

  // 	// 		// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
  // 	// 		this.updateReservationCB(data);

  // 	// 		// close the dialogBox
  // 	// 		dialogRef.close();
  // 	// 	});

  // 	// dialogRef.componentInstance.doDelete.subscribe(
  // 	// 	data => {
  // 	// 		console.log('Dialog output:', data);

  // 	// 		// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
  // 	// 		this.deleteReservationCB(data);

  // 	// 		// close the dialogBox
  // 	// 		dialogRef.close();
  // 	// 	});
  // }

  /*********
   * Edit Button
   *
   */
  onOpenFormEdit(reservation: any) {

    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.maxWidth = '100vw';
    dialogConfig.width = '95vw';
    dialogConfig.maxHeight = '50vw';
    dialogConfig.height = '95vh';
    dialogConfig.panelClass = 'edit-order-mobile';

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      reservationId: reservation.reservationId,
      reservation: reservation,
      showCloseButton: true,
      from: 'reservation-in-out-list',
      title: 'Edit Order'
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(OrderComponent, dialogConfig);
    // this.location1.go('/reservations-edit/' + reservation.reservationId);
    this.location1.go('/order/' + reservation.orderId);

    // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.searchName = data;

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        // this.updateReservationCB(data);
        this.loadLazy(this.lazyLoadEvent);

        // close the dialogBox
        dialogRef.close();
      });

    // dialogRef.componentInstance.doDelete.subscribe(
    // 	data => {
    // 		console.log('Dialog output:', data);

    // 		// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
    // 		this.deleteReservationCB(data);

    // 		// close the dialogBox
    // 		dialogRef.close();
    // 	});
  }

  /**
   *
   * Dialog from Form Callbacks
   * To edit the list show add/edit/delete in real time from the popup form
   *
   */
  addReservationCB(reservation: any) {
    console.log('Adding Reservation: ' + JSON.stringify(reservation));
    // if we don't have a tests array yet...
    if (!this.reservations) {
      this.reservations = [];
    }
    // unshift adds to the front of the array (), push adds to the back
    this.reservations.unshift(reservation);

    // no idea what this is but it is required to update the array
    this.reservations = [...this.reservations];

    this.messageService.add({severity: 'success', summary: 'Success', detail: 'Reservation ' + reservation.reservationId + ' Added', life: 3000});
  }

  updateReservationCB(reservation: any) {
    console.log('Updating Reservation: ' + JSON.stringify(reservation));
    let itemIndex = this.reservations.findIndex((item: any) => item.reservationId === reservation.reservationId);
    this.reservations[itemIndex] = reservation;

    // no idea what this is but it is required to update the array
    this.reservations = [...this.reservations];

    this.messageService.add({severity: 'success', summary: 'Success', detail: 'Reservation ' + reservation.reservationId + ' Updated', life: 3000});
  }

  deleteReservationCB(reservation: any) {
    console.log('Removing Reservation: ' + reservation);
    this.reservations.splice(this.reservations.indexOf(reservation), 1);
    this.recordTotal = this.reservations.length;

    // no idea what this is but it is required to update the array
    this.reservations = [...this.reservations];

    this.messageService.add({severity: 'success', summary: 'Success', detail: 'Reservation ' + reservation.reservationId + ' Deleted', life: 3000});
  }

  onAdvanceSearch() {
    try {

      const dialogConfig = new MatDialogConfig();

      // settings
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.hasBackdrop = true;
      dialogConfig.maxWidth = '45vw';
      dialogConfig.width = '40vw';
      // dialogConfig.height = "45vw";
      // dialogConfig.maxHeight = "60vw";

      // pass data, ie rateBuicket: this.shortTermRentalId,
      dialogConfig.data = {
        advanceSearchData: this.advanceSearchData,
        title: 'Advance Search'
      };

      // open the popup and get a reference to it called dialogRef
      const dialogRef = this.dialog.open(ReservationAdvanceSearchComponent, dialogConfig);
      dialogRef.componentInstance.doSearchCB.subscribe(
        data => {
          this.advanceSearchData = data;
          let event = {'first': 0, 'rows': 50, 'sortOrder': 1, 'globalFilter': null, 'multiSortMeta': []};
          if (this.advanceSearchData) {
            this.advanceSearchDataFilter.filters = {};
            if (this.advanceSearchData.locationIds) {
              let locationIds = [];
              this.advanceSearchData.locationIds.forEach(element => {
                const id = element != null && typeof element === 'object' ? element.locationId : element;
                locationIds.push(id);
              });
              this.advanceSearchDataFilter.filters['shortTermRentalVO.locationId'] = {'value': locationIds, 'matchMode': 'in'};
            }
            if (this.advanceSearchData.shortTermRentalIds) {
              let shortTermRentalIds = [];
              this.advanceSearchData.shortTermRentalIds.forEach(element => {
                const id = element != null && typeof element === 'object' ? element.shortTermRentalId : element;
                shortTermRentalIds.push(id);
              });
              this.advanceSearchDataFilter.filters['shortTermRentalVO.shortTermRentalId'] = {'value': shortTermRentalIds, 'matchMode': 'in'};
            }
            if (this.advanceSearchData.arrivalStartDate) {
              this.advanceSearchDataFilter.filters['checkInDateStart'] = {'value': moment(this.advanceSearchData.arrivalStartDate).format('MM/DD/YYYY'), 'matchMode': 'in'};
            }
            if (this.advanceSearchData.arrivalEndDate) {
              this.advanceSearchDataFilter.filters['checkInDateEnd'] = {'value': moment(this.advanceSearchData.arrivalEndDate).format('MM/DD/YYYY'), 'matchMode': 'in'};
            }
            if (this.advanceSearchData.saleStartDate) {
              this.advanceSearchDataFilter.filters['saleDateStart'] = {'value': moment(this.advanceSearchData.saleStartDate).format('MM/DD/YYYY'), 'matchMode': 'in'};
            }
            if (this.advanceSearchData.saleEndDate) {
              this.advanceSearchDataFilter.filters['saleDateEnd'] = {'value': moment(this.advanceSearchData.saleEndDate).format('MM/DD/YYYY'), 'matchMode': 'in'};
            }
				if (this.advanceSearchData.checkoutStartDate) {
				  this.advanceSearchDataFilter.filters['checkOutDateStart'] = {'value': moment(this.advanceSearchData.checkoutStartDate).format('MM/DD/YYYY'), 'matchMode': 'in'};
				}
				if (this.advanceSearchData.checkoutEndDate) {
				  this.advanceSearchDataFilter.filters['checkOutDateEnd'] = {'value': moment(this.advanceSearchData.checkoutEndDate).format('MM/DD/YYYY'), 'matchMode': 'in'};
				}
				if (this.advanceSearchData.occupyingStartDate) {
				  this.advanceSearchDataFilter.filters['stayDateStart'] = {'value': moment(this.advanceSearchData.occupyingStartDate).format('MM/DD/YYYY'), 'matchMode': 'in'};
				}
				if (this.advanceSearchData.occupyingEndDate) {
				  this.advanceSearchDataFilter.filters['stayDateEnd'] = {'value': moment(this.advanceSearchData.occupyingEndDate).format('MM/DD/YYYY'), 'matchMode': 'in'};
				}
            if (this.advanceSearchData.reservationStatus) {
              this.advanceSearchDataFilter.filters['reservationStatus'] = {'value': this.advanceSearchData.reservationStatus, 'matchMode': 'in'};
            }
            if (this.advanceSearchData.reservationType) {
              this.advanceSearchDataFilter.filters['reservationType'] = {'value': this.advanceSearchData.reservationType, 'matchMode': 'in'};
            }
            if (this.advanceSearchData.lastName) {
              this.advanceSearchDataFilter.filters['guestProfileVO.lastName'] = {'value': this.advanceSearchData.lastName, 'matchMode': 'in'};
            }
            if (this.advanceSearchData.wildcardSearch) {
              this.advanceSearchDataFilter.filters['wildcardSearch'] = {'value': this.advanceSearchData.wildcardSearch, 'matchMode': 'in'};
            }
            // mark advanced filter active to clear default check-in date UI and backend
            this.isAdvanceFilterActive = Object.keys(this.advanceSearchDataFilter.filters).length > 0;
          }
          if (this.eventFilter && Object.keys(this.eventFilter).length > 0) {
            //combine objects
            this.eventFilter = {...this.eventFilter, ...this.advanceSearchDataFilter.filters};
            event['filters'] = this.eventFilter;
          }
          this.loadLazy(event);
          // close the dialogBox
          dialogRef.close();
        });
    } catch (error) {
      console.log('onRowSelect(' + this.advanceSearchDataFilter + ')' + error);
    }
  }

  openCreateReservationPopUp() {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.maxWidth = '40vw';
    dialogConfig.width = '20vw';
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = 'create-reservation-popup';
    // dialogConfig.maxHeight = "50vw";
    // dialogConfig.height = "95vh";

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      showCloseButton: true,
      openNewTab: true
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(ReservationCreateComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        this.loadLazy(this.lazyLoadEvent);

        // close the dialogBox
        dialogRef.close();
      });
  }

  openHelpAlert() {
    this.alertService.success('If you need help or are experiencing any difficulties, please call Dipesh on Ring Central at extension 907.', true);
  }

  exportSelected(exporttype: any) {
    this.importExportComponent.exporData(exporttype, this.reservations, 'Reservations Info');
  }

  sendReservationBalanceDueEmail(reservation) {
    this.reservationService.sendReservationBalanceDueEmail(reservation.reservationId).subscribe(res => {

    });
  }

  runAutoPayment(reservation) {
    this.reservationService.autoPayReservationBalance(reservation.reservationId).subscribe(res => {

    });
  }

  // Helper method to truncate text to approximately 2 lines
  truncateText(text: string, maxLength: number = 100): string {
    if (!text || text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + '...';
  }

  // Toggle expanded state for opsNotes
  toggleOpsNotes(reservationId: string) {
    this.expandedOpsNotes[reservationId] = !this.expandedOpsNotes[reservationId];
  }

  // Check if opsNotes is expanded
  isOpsNotesExpanded(reservationId: string): boolean {
    return this.expandedOpsNotes[reservationId] || false;
  }

  // Check if text needs truncation
  needsTruncation(text: string, maxLength: number = 50): boolean {
    return text && text.length > maxLength;
  }

  getAdvanceSearchDataCount() {
    if (!this.advanceSearchData || typeof this.advanceSearchData !== 'object') {
      return 0;
    }
    
    let count = 0;
    const searchData = this.advanceSearchData;
    
    // Count non-empty search criteria
    if (searchData.locationIds && searchData.locationIds.length > 0) count++;
    if (searchData.shortTermRentalIds && searchData.shortTermRentalIds.length > 0) count++;
    if (searchData.arrivalStartDate) count++;
    if (searchData.arrivalEndDate) count++;
    if (searchData.saleStartDate) count++;
    if (searchData.saleEndDate) count++;
    if (searchData.reservationStatus) count++;
    if (searchData.reservationType) count++;
    if (searchData.lastName && searchData.lastName.trim() !== '') count++;
    if (searchData.wildcardSearch && searchData.wildcardSearch.trim() !== '') count++;
    
    return count;
  }

}

